import styled from 'styled-components';
import { Dropdown } from 'react-bootstrap';

export const StyledDropdownMenu = styled(Dropdown.Menu)`
    display: flex !important;
    flex-direction: column;
    position: absolute;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    min-width: 30px;
    overflow: hidden;
`;

export const StyledDropdownItem = styled(Dropdown.Item)`
    background: none !important;
    border: none;
    padding: 8px 16px !important;
    text-align: left;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 12px;
    color: #1a1a1a !important;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
    border-bottom: 1px solid #f5f5f5;
    border-left: 3px solid transparent;

    svg {
        font-size: 18px;
        color: #0f766e;
    }

    &:hover {
        background: linear-gradient(90deg, rgba(15, 118, 110, 0.05) 0%, transparent 100%) !important;
        color: #06b6d4;
        border-left-color: #06b6d4;
        transform: translateX(4px);
        padding-left: 13px !important;

        svg {
            color: #06b6d4;
            transform: scale(1.1);
        }
    }

    &:active {
        background: linear-gradient(90deg, rgba(15, 118, 110, 0.1) 0%, transparent 100%) !important;
        transform: translateX(2px);
    }

    &:last-child {
        border-bottom: none;
    }
`;